/**
 * showToast sets the initial settings for toastr and creates the window.initToast function
 *
 * window.initToast shows a toast with the given message and color.
 * If a parameter is not given, it is replaced with a dummy variable.
 * - message: String       (Any message to display, ie 'This is my message')
 * - color: String         (Any of the color options of toastr: 'success', 'info', 'warning' or 'error')
 * - title: String         (Any title to display, ie 'This is my title'.)
 *
 * Dependencies
 * - toastr http://codeseven.github.io/toastr/
 */

function showToast () {
	toastr.options = {
		closeButton: false,
		debug: false,
		newestOnTop: false,
		progressBar: false,
		positionClass: 'toast-top-right',
		preventDuplicates: false,
		onclick: null,
		showDuration: '100',
		hideDuration: '0',
		timeOut: '5000',
		extendedTimeOut: '10',
		showEasing: 'swing',
		hideEasing: 'linear',
		showMethod: 'slideDown',
		hideMethod: 'slideUp'
	};

	function initToast (message, color, title) {
		const m = message != null ? message : '';
		const c = color != null ? color : 'info';
		if (color != 'info') {
			console.log('toast', color, title, message);
		}
		if (title) {
			toastr[c](m, title);
		} else {
			toastr[c](m);
		}
	}

	window.initToast = initToast;
}
showToast();
